module.exports = __webpack_public_path__ + "media/images/icon-facebook-share@3x-04fc159c6d9798816cee3b0765e59f2a.png";